import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Interview } from './interview';
export { Interview };
import { interviewSchema } from '@schemas/business-objects/interview';
import { CandidateFormGroup } from './candidate-form-group';
import { InterviewMotivationFormGroup } from './interview-motivation-form-group';
import { InterviewObservationFormGroup } from './interview-observation-form-group';
import { InterviewProblemSolvingFormGroup } from './interview-problem-solving-form-group';
import { InterviewStressResistanceFormGroup } from './interview-stress-resistance-form-group';
import { InterviewTeamworkFormGroup } from './interview-teamwork-form-group';
import { UserFormGroup } from './user-form-group';

export class InterviewFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    interviewDate: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
    interviewerId: SchemaFormControl;
    interviewer: UserFormGroup;
    interviewMotivation: InterviewMotivationFormGroup;
    interviewTeamwork: InterviewTeamworkFormGroup;
    interviewProblemSolving: InterviewProblemSolvingFormGroup;
    interviewStressResistance: InterviewStressResistanceFormGroup;
    interviewObservation: InterviewObservationFormGroup;
  };

  declare value: Partial<Interview>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(interviewSchema, Interview, data, options);
  }

  get object(): Interview {
    return new Interview(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      case 'interviewer':
        return new UserFormGroup();
      case 'interviewMotivation':
        return new InterviewMotivationFormGroup();
      case 'interviewTeamwork':
        return new InterviewTeamworkFormGroup();
      case 'interviewProblemSolving':
        return new InterviewProblemSolvingFormGroup();
      case 'interviewStressResistance':
        return new InterviewStressResistanceFormGroup();
      case 'interviewObservation':
        return new InterviewObservationFormGroup();
      default:
        return undefined;
    }
  }
}

export class InterviewFormArray extends PersistedFormArray {
  readonly entityName = 'Interview' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(interviewSchema, Interview, options);
  }

  protected override createItemGroup() {
    return new InterviewFormGroup();
  }

  get array(): Interview[] {
    return this.controls.map((group: InterviewFormGroup) => group.object);
  }
}

export class InterviewPersistedArray extends PersistedArray<Interview> {
  readonly entityName = 'Interview' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Interview, options);
  }
}
